import { Injectable } from '@angular/core';
import { CEUMA_URL_POS_GRADUACAO } from 'app/config';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DadosInscricoes } from './inscricoes';
export const INSCRICAO_API_URL = CEUMA_URL_POS_GRADUACAO + '/recuperaInscricoes';

@Injectable()
export class AcompanhamentoService {

  private headers: HttpHeaders = new HttpHeaders({
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  });

  private dadosInscricoes: DadosInscricoes;


  constructor(private http: HttpClient) { }


  getInscricoes(cpf) {
    return this.http.post(INSCRICAO_API_URL, { cpf }, { headers: this.headers });
  }

  setDadosInscricoes(payload) {
    this.dadosInscricoes = new DadosInscricoes(payload);
  }

  getDadosInscricoes() {
    return this.dadosInscricoes;
  }

}
